const styles = {
    main: {
        color: "#F2F1EB",
    },
    header: {
        textAlign: "center",
        marginBottom: "1rem",
        backgroundColor: "#F2F1EB",
        color: "#13120F",
        fontSize: "2rem",
        fontFamily: "Avigea, serif",
        letterSpacing: "0.05em",
    },
    submodule: {
        textAlign: "center",
        marginBottom: "1rem",
        backgroundColor: "#F2F1EB",
        color: "#13120F",
        fontSize: "1.25rem",
        fontWeight: "bold",
        boxShadow: "0 4px 15px rgb(0, 57, 51)",
        fontFamily: "Nexa-Heavy, sans-serif",
        letterSpacing: "0.05em",
        padding: "1rem",
    },
    vowelContainer: {
        padding: "0.25rem",
        borderRadius: "0.25rem",
        backgroundColor: "#F2F1EB",
        color: "#13120F",
        fontSize: "1.5rem",
        fontFamily: "Nexa-Heavy, sans-serif",
        letterSpacing: "0.05em",
    },
    vowelSelect: {
        marginLeft: "0.5rem",
        padding: "0.25rem",
        borderRadius: "0.25rem",
        border: "1px solid #6c584c",
        backgroundColor: "#f0ead2",
        color: "#13120F",
        fontSize: "1.5rem",
        fontFamily: "Nexa-Heavy, sans-serif",
        letterSpacing: "0.05em",
    },
    buttons: {
        backgroundColor: "#f0ead2",
        color: "#13120F",
        hover: "#f0ead2",
        fontFamily: "Nexa-Heavy, sans-serif",
        letterSpacing: "0.05em",
    },
    canvasContainer: {
        fontSize: "1rem",
        color: "#13120F",
        fontWeight: "bold",
        textAlign: "center",
    },
    audioPlayer: {
        padding: "0.25rem",
        borderRadius: "0.25rem",
        backgroundColor: "#F2F1EB",
        color: "#f0ead2",
        fontSize: "1rem",
        fontFamily: "Nexa-Heavy, sans-serif",
        letterSpacing: "0.05em",
        width: "100%",
        display: "block",
        boxSizing: "border-box",
    },
    offcanva: {
        backgroundColor: "#00a896",
        color: "#f0ead2",
        fontFamily: "Nexa-Heavy, sans-serif",
        letterSpacing: "0.05em",
        fontSize: "1.5rem",
    },
    ofLinks: {
        color: "#f0ead2",
        backgroundColor: "#00a896",
        fontSize: "1.1rem",
        marginBottom: "0.5rem",
        // hover effect
        hover: {
            color: "#F3540F",
            backgroundColor: "#f0ead2",
        },
        fontFamily: "Nexa-Heavy, sans-serif",
        letterSpacing: "0.05em",
    },
};

export default styles;
